(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-resmed"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Dynamic count updates when load-more appends new cards
  document.addEventListener('DOMContentLoaded', () => {
    const list = document.querySelector('results-list[section-id]');
    if (!list) return;
    const grid = list.querySelector('[ref="grid"]');
    if (!grid) return;

    const updateCounts = () => {
      const topText = list.querySelector('.resmed-products-count');
      const total = parseInt(topText?.dataset.total ?? '0');
      if (!total) return;

      const shown = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
      if (topText) {
        const tmpl = topText.dataset.i18nShowing;
        topText.textContent = tmpl
          ? tmpl.replace('__shown__', shown).replace('__total__', total)
          : `${shown} / ${total}`;
      }

      const loadMore = list.querySelector('.plp-load-more');
      if (loadMore) {
        const bottomText = loadMore.querySelector('.plp-load-more__text');
        if (bottomText) {
          const tmpl = loadMore.dataset.i18nViewed;
          bottomText.textContent = tmpl
            ? tmpl.replace('__shown__', shown).replace('__total__', total)
            : `${shown} / ${total}`;
        }
        const loadMoreBtn = loadMore.querySelector('.plp-load-more__button');
        if (loadMoreBtn) loadMoreBtn.hidden = shown >= total;
      }
    };

    new MutationObserver(updateCounts).observe(grid, { childList: true });
    updateCounts();
  });

  // "Load More" button click — scroll the real viewMoreNext span into view
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    const list = btn.closest('results-list');
    const trigger = list?.querySelector('[ref="viewMoreNext"]');
    if (trigger) trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results-resmed"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const list = document.querySelector('results-list[section-id]');
    if (!list) return;
    const grid = list.querySelector('[ref="grid"]');
    if (!grid) return;

    const updateCounts = () => {
      const topText = list.querySelector('.resmed-products-count');
      const total = parseInt(topText?.dataset.total ?? '0');
      if (!total) return;

      const shown = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
      if (topText) {
        const tmpl = topText.dataset.i18nShowing;
        topText.textContent = tmpl
          ? tmpl.replace('__shown__', shown).replace('__total__', total)
          : `${shown} / ${total}`;
      }

      const loadMore = list.querySelector('.plp-load-more');
      if (loadMore) {
        const bottomText = loadMore.querySelector('.plp-load-more__text');
        if (bottomText) {
          const tmpl = loadMore.dataset.i18nViewed;
          bottomText.textContent = tmpl
            ? tmpl.replace('__shown__', shown).replace('__total__', total)
            : `${shown} / ${total}`;
        }
        const loadMoreBtn = loadMore.querySelector('.plp-load-more__button');
        if (loadMoreBtn) loadMoreBtn.hidden = shown >= total;
      }
    };

    new MutationObserver(updateCounts).observe(grid, { childList: true });
    updateCounts();
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    const list = btn.closest('results-list');
    const trigger = list?.querySelector('[ref="viewMoreNext"]');
    if (trigger) trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();
})();
